import React from 'react'
// import archivoListado from '../../assets/files/Concurso/CONCURSO DEPGFMLUZ 2025 LISTADO DEFINITIVO.pdf'

const ConcursoInscripciones = () => {
  const formLink = 'https://docs.google.com/forms/d/e/1FAIpQLSeBQ88nUPBz_-hs_CkmUkMZ80T5m7lfW6BuacEtX-tdlRkttQ/viewform?usp=preview'

  return (
    <div className='page-section instructivos listado-ganadores'>
        <section className='info-container listado-ganadores' id='index'>
          
          {/* <h3 className='section-title'>Listado de Ganadores del Concurso 2024</h3> */}

          {/* <div className='info-group column mb-4'>
            <a 
              href={archivoListado}
              target='blank'
              // download={'CONCURSO DEPGFMLUZ 2025 LISTADO DEFINITIVO'} 
              className='btn-baremo rd btn btn-primary link-button px-4'
            >
              Ver Listado
            </a>
          </div> */}
          
          <div className='info-group mt-3'>
            <h3 className='page-subtitle border-none'>Cronograma de Inscripción</h3>
            <p dangerouslySetInnerHTML={{__html: '<b>Fecha de inscripción:</b> por terminal de documento de identidad cédula o pasaporte (en el caso de extranjeros): '}}></p>
            <p hidden>Fecha de inscripción por terminal de documento de identidad cédula o pasaporte (en el caso de extranjeros): </p>
            <ul className='lista-inscripcion fechas mb-4'>
              <li className='span-group'>
                <span className='span-lead'>Miércoles 05/11: </span>
                <span>1, 2, 3, 4</span>
              </li>
              <li className='span-group'>
                <span className='span-lead'>Jueves 06/11: </span>
                <span>5, 6, 7</span>
              </li>
              <li className='span-group'>
                <span className='span-lead'>Viernes 07/11: </span>
                <span>8, 9, 0</span>
              </li>
            </ul>

            <div className='callout info mb-2'>
              <i class="bi bi-info-circle icon"></i>
              <p>Este formulario debe ser llenado de forma inmediata, para que administración  se comunique con usted los días lunes 03 o martes 04 para explicarle la forma de inscripción.</p>
            </div>
          </div>
          <div className='info-group list-column'>
            <h4 className='group-title sm mb-3'>Pasos para realizar la inscripción: </h4>
            <ol className='lista-inscripcion'>
              <li>Llenar el formulario de inscripción ubicado al final de esta página. </li>
              <li>Administración se comunicará con Usted vía WhatsApp, para indicarle los aranceles de inscripción. </li>
            </ol>
          </div>
          {/* <div className='info-group list-column'>
            <h4 className='group-title sm'>Entrega de la Carta de Asignación de Cupo: </h4>
            <div className='span-group'>
              <span className='span-lead'>Día: </span>
              <span>sábado 04 de enero de 2025.</span>
            </div>
          </div> */}

          

          <div className='info-group list-column mb-4'>
            <h4 className='group-title sm'>Inicio de Clases</h4>
            <p className=''>Lunes 05 de enero de 2026</p>
          </div>

          <div className='info-group mb-0'>
            <a
              href={formLink}
              target='blank'
              className='btn-baremo btn btn-primary rd link-button px-4'
            >
              Formulario de Inscripción
            </a>
          </div>

          <div className='info-group list-column' hidden>
            <p className='name-p lead-name'>Dr. Freddy Pachano Arenas<br/>Director</p>
            <p className='name-p'>Dra. Jorymar Leal<br/>Secretaria Docente</p>
          </div>
        </section>
    </div>
  )
}

export { ConcursoInscripciones }